import { useCallback, useMemo } from "react"

import { useMatch } from "react-router-dom"

import { MapWithPhotoViewer } from "@l2r-front/l2r-common"
import { useImageCollectionStateContext, useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { ReactMapGl, useMapContext } from "@l2r-front/l2r-map"
import { useIsFetchingNetwork, useNetworksStateContext } from "@l2r-front/l2r-networks"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { appDocument } from "../../constants/appDocument"

export function Map(props) {

    const {
        children,
        mapProps,
        ...otherProps
    } = props

    const isFetchingNetwork = useIsFetchingNetwork()
    const isFetching = isFetchingNetwork
    const { getSelectedNetworkBoundingBox } = useNetworksStateContext()
    const [mapState, mapDispatch] = useMapContext()
    const { onOpenImageViewer, onSwitchImageLayer, isImageCollectionAvailable } = useImageCollectionDispatchContext()
    const { imageLayerDisplayed } = useImageCollectionStateContext()
    const { setMapBoundingBoxToFit } = mapDispatch
    const { error } = mapState

    const mapInitialViewState = useMemo(() => {
        const [minLng, minLat, maxLng, maxLat] = getSelectedNetworkBoundingBox()
        return {
            longitude: (minLng + maxLng) / 2,
            latitude: (minLat + maxLat) / 2,
            zoom: 8,
        }
    }, [getSelectedNetworkBoundingBox])

    const onRecenterOnNetworkBoundingBox = useCallback(() => {
        const [minLng, minLat, maxLng, maxLat] = getSelectedNetworkBoundingBox()
        setMapBoundingBoxToFit({
            minLng,
            minLat,
            maxLng,
            maxLat,
        })
    }, [getSelectedNetworkBoundingBox, setMapBoundingBoxToFit])

    const onSwitchImageLayerCallback = isImageCollectionAvailable() ? onSwitchImageLayer : undefined
    const match = useMatch("/:networkId/:modules/:subModule/*")
    const subModule = match?.params.subModule
    const module = Object.values(appDocument.modules).find(m => m.path === subModule)?.id

    return (
        <MapWithPhotoViewer
            dragRotate={false}
            error={error}
            initialViewState={mapInitialViewState}
            isLoading={isFetching}
            imageLayerDisplayed={imageLayerDisplayed}
            module={module}
            onOpenImageViewer={onOpenImageViewer}
            onSwitchImageLayer={onSwitchImageLayerCallback}
            onRecenter={onRecenterOnNetworkBoundingBox}
            {...mapProps}
            {...otherProps}
        >
            {children}
        </MapWithPhotoViewer>
    )
}

Map.propTypes = {
    ...ReactMapGl.propTypes,
    className: PropTypes.string,
}